import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface BulkConfirmDeleteProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  count: number
  /** Number of selected rows that are AI-extracted (will regenerate on next extract). */
  aiCount?: number
  /** Singular noun used in the prompt (e.g. "risk", "item", "date"). */
  itemNoun: string
  onConfirm: () => void
}

function aiPhrase(count: number, aiCount: number): string {
  // count === aiCount: every selected row is AI-extracted.
  if (count === aiCount) {
    return count === 1
      ? 'It is AI-extracted and may reappear the next time the analysis is re-run.'
      : `All ${count} are AI-extracted and may reappear the next time the analysis is re-run.`
  }
  // Mixed: aiCount < count.
  if (aiCount === 1) {
    return '1 of them is AI-extracted and may reappear the next time the analysis is re-run.'
  }
  return `${aiCount} of them are AI-extracted and may reappear the next time the analysis is re-run.`
}

export function BulkConfirmDelete({
  open,
  onOpenChange,
  count,
  aiCount = 0,
  itemNoun,
  onConfirm,
}: BulkConfirmDeleteProps) {
  const plural = count === 1 ? itemNoun : `${itemNoun}s`

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Delete {count} {plural}?
          </AlertDialogTitle>
          <AlertDialogDescription>
            This permanently removes {count === 1 ? 'this' : 'these'} {plural} from the bid.
            {aiCount > 0 && <> {aiPhrase(count, aiCount)}</>}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
